import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2498ccf6")

_pushScopeId("data-v-2498ccf6")
const _hoisted_1 = { class: "items-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "pagination mt-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-left font-size-24" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-right font-size-24" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", {
    class: ["text-gray-333", {
      'fixed-header': $props.fixedHeader,
      border: !($props.showPagination && $setup.pagesTotal > 1),
    }],
    style: 
      !($props.showPagination && $setup.pagesTotal > 1) && {
        overflow: $props.visibleTable ? 'visible' : 'auto',
      }
    
  }, [
    _createVNode("div", {
      class: {
        border: $props.showPagination && $setup.pagesTotal > 1,
      },
      style: 
        $props.showPagination &&
        $setup.pagesTotal > 1 && { overflow: $props.visibleTable ? 'visible' : 'auto' }
      
    }, [
      _createVNode("table", {
        class: [$setup.classes, "w-full"]
      }, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers, (item) => {
                return (_openBlock(), _createBlock("th", {
                  key: item.value,
                  style: {
                  width: item.width,
                  minWidth: item.width,
                  textAlign: item.align,
                }
                }, [
                  ($props.showSelect && item.value === 'checkbox')
                    ? _renderSlot(_ctx.$slots, "header-checkbox", {
                        key: 0,
                        item: item
                      }, () => [
                        _createVNode("div", _hoisted_1, [
                          _createVNode("span", _hoisted_2, _toDisplayString(item.text), 1),
                          _createVNode(_component_Checkbox, {
                            classes: "justify-center",
                            onChange: $setup.onSelectedAll,
                            modelValue: $setup.isCheckAll,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.isCheckAll = $event))
                          }, null, 8, ["onChange", "modelValue"])
                        ])
                      ], true)
                    : (item.type === 'html')
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          innerHTML: item.text
                        }, null, 8, ["innerHTML"]))
                      : _renderSlot(_ctx.$slots, `header-` + item.value, {
                          key: 2,
                          item: item
                        }, () => [
                          _createTextVNode(_toDisplayString(item.text), 1)
                        ], true)
                ], 4))
              }), 128))
            ])
          ])
        ], {}, true),
        _renderSlot(_ctx.$slots, "body", {}, () => [
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.data, (item, index) => {
              return (_openBlock(), _createBlock("tr", {
                key: item.id
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers, (header) => {
                  return (_openBlock(), _createBlock("td", {
                    key: header.value,
                    style: {
                  background: header.background,
                  verticalAlign: header.verticalAlign,
                },
                    class: "break-all"
                  }, [
                    _renderSlot(_ctx.$slots, header.value, {
                      item: item,
                      index: index
                    }, () => [
                      (header.value === 'checkbox')
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 0,
                            classes: "justify-center",
                            value: item,
                            modelValue: $setup.selectedItemList,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.selectedItemList = $event)),
                            onChange: $setup.onSelected
                          }, null, 8, ["value", "modelValue", "onChange"]))
                        : (_openBlock(), _createBlock("span", {
                            key: 1,
                            class: !header.whitespace ? 'whitespace-pre' : ''
                          }, _toDisplayString(item[header.value]), 3))
                    ], true)
                  ], 4))
                }), 128))
              ]))
            }), 128)),
            ($props.data.length === 0 && !$setup.isLoading)
              ? _renderSlot(_ctx.$slots, "no-data", { key: 0 }, () => [
                  _createVNode("tr", null, [
                    _createVNode("td", {
                      colspan: $props.headers.length,
                      class: "text-center"
                    }, _toDisplayString($setup.t('noData')), 9, ["colspan"])
                  ])
                ], {}, true)
              : _createCommentVNode("", true)
          ])
        ], {}, true)
      ], 2)
    ], 6),
    ($props.showPagination && $setup.pagesTotal > 1)
      ? _renderSlot(_ctx.$slots, "pagination", { key: 0 }, () => [
          _createVNode("div", _hoisted_3, [
            _createVNode("a", {
              class: { 'pointer-events-none': $props.currentPage === 1 },
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changePages($props.currentPage - 1)))
            }, [
              _hoisted_4
            ], 2),
            _createVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changePages(1))),
              class: { active: $setup.isActive(1) }
            }, " 1 ", 2),
            ($props.currentPage - 3 >= 1 && $setup.pagesTotal > 4)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  style: {"align-items":"normal"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changePages($props.currentPage - 3)))
                }, " ... "))
              : _createCommentVNode("", true),
            ($props.currentPage - 2 > 1 && $props.currentPage === $setup.pagesTotal)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changePages($props.currentPage - 2))),
                  class: { active: $setup.isActive($props.currentPage - 2) }
                }, _toDisplayString($props.currentPage - 2), 3))
              : _createCommentVNode("", true),
            ($props.currentPage - 1 > 1)
              ? (_openBlock(), _createBlock("a", {
                  key: 2,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.changePages($props.currentPage - 1))),
                  class: { active: $setup.isActive($props.currentPage - 1) }
                }, _toDisplayString($props.currentPage - 1), 3))
              : _createCommentVNode("", true),
            ($props.currentPage !== 1 && $props.currentPage < $setup.pagesTotal)
              ? (_openBlock(), _createBlock("a", {
                  key: 3,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.changePages($props.currentPage))),
                  class: { active: $setup.isActive($props.currentPage) }
                }, _toDisplayString($props.currentPage), 3))
              : _createCommentVNode("", true),
            ($props.currentPage + 1 < $setup.pagesTotal)
              ? (_openBlock(), _createBlock("a", {
                  key: 4,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.changePages($props.currentPage + 1))),
                  class: { active: $setup.isActive($props.currentPage + 1) }
                }, _toDisplayString($props.currentPage + 1), 3))
              : _createCommentVNode("", true),
            ($props.currentPage + 2 < $setup.pagesTotal && $props.currentPage === 1)
              ? (_openBlock(), _createBlock("a", {
                  key: 5,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.changePages($props.currentPage + 2))),
                  class: { active: $setup.isActive($props.currentPage + 2) }
                }, _toDisplayString($props.currentPage + 2), 3))
              : _createCommentVNode("", true),
            ($props.currentPage + 3 <= $setup.pagesTotal && $setup.pagesTotal > 4)
              ? (_openBlock(), _createBlock("a", {
                  key: 6,
                  style: {"align-items":"normal"},
                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.changePages($props.currentPage + 3)))
                }, " ... "))
              : _createCommentVNode("", true),
            ($setup.pagesTotal !== 1)
              ? (_openBlock(), _createBlock("a", {
                  key: 7,
                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.changePages($setup.pagesTotal))),
                  class: { active: $setup.isActive($setup.pagesTotal) }
                }, _toDisplayString($setup.pagesTotal), 3))
              : _createCommentVNode("", true),
            _createVNode("a", {
              class: { 'pointer-events-none': $props.currentPage === $setup.pagesTotal },
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.changePages($props.currentPage + 1)))
            }, [
              _hoisted_5
            ], 2)
          ])
        ], {}, true)
      : _createCommentVNode("", true)
  ], 6))
})